import React, {useContext, useState} from 'react'
import DashboardCards from '../../Components/Advertisers/DashboardCards'
import SideDrawer from '../../Components/Advertisers/SideDrawer'
import {
  Container,
  Grid,
  Divider, Button, Box,
} from '@material-ui/core'
import useAxios from "axios-hooks";

import CustomText from '../../Components/Universal/CustomText';
import {DashboardContext} from "./Dashboard/context";
import ContentDiv from "../../Components/Universal/ContentDiv";
import WizardStep1 from "./Campaigns/components/WizardStep1";
import {countAudience} from "../../Api";
import {getFieldChangeSetter, WizardContext, WizardDefaultContext} from "./Campaigns/context";
import { useStyles } from "./Auth/styles";

export default function Overview (props) {
  const {advertiser} = useContext(DashboardContext);
  const [{loading: audienceLoading, data: audienceCountData}, countAudienceAction] = useAxios(countAudience(), { manual: true });
  const [formData, setFormData] = useState({...WizardDefaultContext.formData});
  const classes = useStyles();
  const changeCallback = (name, targeting, value, finalData) => {
    if (name === 'targeting' || name === 'location' || targeting) {
      countAudienceAction({
        data: {
          targeting: finalData.targeting,
          location: finalData.location,
        },
      });
    }
  };

  const handleCampaignCreate = () => {
    localStorage.setItem('home-targeting', JSON.stringify({
      ...formData.targeting,
    }));
    props.history.replace('/advertiser/campaigns/create');
  };

  return (
    <SideDrawer>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomText
            text={`Account Overview: ${advertiser.advertiser_business_name}`}
            style='titleLarge'
            margin='55px 0 0 0'
          />
        </Grid>
        <DashboardCards campaignEvents={props.campaignEvents}/>
      </Grid>
      <ContentDiv>
        <Container component="main">
          <WizardContext.Provider value={{formData, fieldChange: getFieldChangeSetter(formData, setFormData, changeCallback)}}>
            <div>&nbsp;</div>
            <div style={{ fontSize: 28, padding: '8px 16px', color: '#03A9F4' }}>Pre-Campaign Search</div>
            <Divider />
            <div>&nbsp;</div>
            <WizardStep1 showTargetDropdown={false} audienceCount={audienceCountData ?  audienceCountData.total : 'All'} />

            <Box display="flex" justifyContent="center" mt={4}>
              <Button
                variant="contained"
                color="primary"
                className={classes.mainButton}
                onClick={handleCampaignCreate}
                style={{
                  border: '3px solid #03A9F4',
                  padding: '16px',
                  width: 220
                }}
              >
                Create Campaign to this audience
              </Button>
            </Box>
          </WizardContext.Provider>
        </Container>
      </ContentDiv>
    </SideDrawer>
  )
}
